import React from "react";

const QuotationList = React.lazy(() => import("./QuotationList"));

export default {
  list: QuotationList,
};
